import React from 'react';
import { NavLink } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import * as Icon from 'react-feather';
import { useAuthUser } from 'react-auth-kit';
import { canPageAction, getMenuSections, hasAccessToSection } from '../../../config/roleConfig';
import './SideMenu.css';

const SECTION_ICONS = {
    operaciones: Icon.Settings,
    rrhh: Icon.Users,
    ventas: Icon.ShoppingCart,
    finanzas: Icon.DollarSign,
    facturacion: Icon.BarChart2,
    cliente: Icon.User,
};

const SideMenuDark = (props) => {
    const authUser = useAuthUser();
    const user = authUser();
    const menuSections = getMenuSections();

    const canAccess = (sectionId) => {
        return hasAccessToSection(user, sectionId);
    };

    const renderIcon = (iconName, className = 'icon') => {
        const IconComponent = Icon[iconName];
        return IconComponent ? <IconComponent className={className} /> : null;
    };

    const renderSection = (section) => {
        const SectionIcon = SECTION_ICONS[section.id] || Icon.Circle;
        const visibleItems = section.items.filter(item =>
            canPageAction(user, item.pageKey, 'read')
        );

        if (visibleItems.length === 0) {
            return null;
        }

        if (section.standalone) {
            const item = visibleItems[0];

            return (
                <NavLink key={section.id} to={item.route} className="nav-link">
                    {renderIcon(item.icon)}
                    <span className="title">{item.label}</span>
                </NavLink>
            );
        }

        return (
            <NavDropdown
                key={section.id}
                className="super-color"
                title={
                    <div className="dropdown-title">
                        <SectionIcon className="icon" />
                        <span className="title">
                            {section.title}
                            <Icon.ChevronRight className="icon fr" />
                        </span>
                    </div>
                }
                id={`${section.id}-dropdown`}
            >
                {visibleItems.map(item => (
                    <NavLink
                        key={item.route}
                        to={item.route}
                        activeClassName="drpMenu"
                        className="dropdown-item"
                    >
                        {renderIcon(item.icon)}
                        <span className="title">{item.label}</span>
                    </NavLink>
                ))}
            </NavDropdown>
        );
    };

    return (
        <div className={`sidemenu-area ${props.sideMenu ? 'sidemenu-toggle' : ''}`}>
            <Navbar className={`sidemenu ${props.sideMenu ? 'hide-nav-title' : ''}`} >
                <Navbar.Collapse>
                    <Nav>
                        {menuSections
                            .filter(section => canAccess(section.id))
                            .map(section => renderSection(section))}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
};

export default SideMenuDark;
